import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { logout, onForbidden } from '../account/login';
import { fetchSubmitForm, fetchSubmitFormFailed, resetSubmitFormData } from './../common/submitForm';
import { getPendingAccreditationDataById } from './pendingAccreditations';
import _ from 'lodash';

//- Actions
export const fetchGetVIDsFailed = createAction('FETCH_GET_ALL_VIDS_FAILED');
export const fetchGetVIDsSuccess = createAction('FETCH_GET_ALL_VIDS_SUCCESS');
export const fetchGetVIDs = createAction(
    'FETCH_GET_ALL_VIDS',
    () => Api.getAllVIDs(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetVIDsSuccess,
        onFail: fetchGetVIDsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetVIDsForList = createAction(
    'FETCH_GET_ALL_VIDS_FOR_LIST',
    () => Api.getAllVIDs(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetVIDsSuccess,
        onFail: fetchGetVIDsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onUpdateVIDSuccess = () => (dispatch) => {
    dispatch(resetSubmitFormData());
    dispatch(fetchGetVIDsForList());
};
export const fetchUpdateVID = (id, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateVID(id, data));
};
export const onUpdateVID = createAction(
    'FETCH_VID_ACCREDITATION',
    (id, data) => Api.updateVID(id, data),
    () => ({
        apiCall: true,
        onSuccess: onUpdateVIDSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchActivateVID = (id) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onActivateVID(id));
};
export const onActivateVID = createAction(
    'FETCH_VID_ACTIVATE',
    (id) => Api.activateVID(id),
    () => ({
        apiCall: true,
        onSuccess: onUpdateVIDSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({

    FETCH_GET_ALL_VIDS: (state) => {
        return { ...state, data: null, error: null, fetching: true };
    },
    FETCH_GET_ALL_VIDS_FOR_LIST: (state) => {
        return { ...state, error: null, fetching: true };
    },
    FETCH_GET_ALL_VIDS_FAILED: (state, action) => {
        return { ...state, data: null, error: action.payload, fetching: false };
    },
    FETCH_GET_ALL_VIDS_SUCCESS: (state, action) => {
        return { ...state, data: action.payload, error: null, fetching: false };
    }

}, initialState);

//- Selectors
export const getVIDs = state => state.VIDs;

export const getVIDsLoading = state => getVIDs(state).fetching;

export const getVIDsData = state => getVIDs(state).data;

export const isVIDEditable = (state, id) => {
    let data = getVIDsData(state);
    let accreditationData = getPendingAccreditationDataById(state, id);

    if (_.isNil(accreditationData) || _.isNil(accreditationData.verifiedIdentity) || _.isNil(data)){
        return null;
    }

    let accreditationVID = getPendingAccreditationDataById(state, id).verifiedIdentity;

    return !data.find((elem) => {
        return (elem.countryCode === accreditationVID.countryCode && elem.nationalId === accreditationVID.nationalId)
    })
};

export const loadingVIDs = state => getVIDs(state).fetching;



// WEBPACK FOOTER //
// ./src/reducers/applicantAccreditations/VIDs.js